import React from 'react';

export function IOSDeliveryCopy() {
  return (
    <div className="ios-copy">
      <div className="ios-eyebrow">Exclusive for Toshokan Pass members</div>
      <h2>The Zenzeii reader on your phone.</h2>
      <p>
        Before the App Store launch, members receive a personal download link
        for the full iOS reader.
      </p>
      <div className="ios-meta">iOS only · Early access for members</div>
    </div>
  );
}

export default IOSDeliveryCopy;
